<template>
  <div class="home-body">
    <div class="wrap-blue banner-with-copy">
      <div class="row">

        <div class="col-xs-12 col-md-6 col-md-push-6  pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/about/banner2_400.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/about/banner2_600.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/about/banner2_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/about/banner2_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/about/banner2_800.jpg" alt="">
          </picture>
          <div class="overlay"></div>
        </div>
        <div class="col-xs-12 col-md-6 col-md-pull-6 banner-content-wrap">
          <div class="banner-copy">
            <h1>Together <br />We Learn</h1>
            <p>
              We are truly a learning company inside and out! Our goal is to provide the best learning resources and never stop improving, just like the learners we serve. Our ongoing research and development will ensure we deliver the tools that best serve your needs.
            </p>
            <router-link :to="{name: 'features'}" class="btn-pub btn-pub-blank xs-full-width">Learn More</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container ptb-100">
      <div class="row">
        <div class="col-xs-12 col-sm-9 large-text">
          <p class="large-text">
            CLEX stands for <strong>Contextual Learning Experience</strong>. True to our name, CLEX Software is a web-based study tool dedicated to improving an individual’s capacity for learning by utilizing an individually optimized methodology to maximize each user’s studying potential.
            We allows learners to organize study materials into micro-notes, identify keywords in their lessons, and prioritize what you need to study.
          </p>
          <p class="large-text">
            CLEX is all about bringing learners together through study communities.
          </p>
          <p class="large-text">
            We give you the ability to challenge yourself using individualized study levels, that you can control. It's our mission that as learners advance through their studies, their confidence grows. CLEX combines content from multiple sources into organized modules and it’s accessible anywhere you go.
          </p>
        </div>
        <div class="hidden-xs col-sm-3">
          <AdBlock :slot-id="2" :count="1"></AdBlock>
        </div>
      </div>
    </div>

    <div class="wrap-black banner-with-copy bottom-banner">
      <div class="row">
        <div class="col-xs-12 col-sm-6 pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/about/banner3_400.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/about/banner3_600.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/about/banner3_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/about/banner3_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/about/banner3_800.jpg" alt="">
          </picture>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="banner-copy">
            <p class="x-large-text">
              CLEX offers a <strong>FREE</strong> study service that is results oriented for all students.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container ptb-100">
      <div class="row">
        <div class="col-xs-12 col-sm-9">
          <p class="large-text">
            CLEX is aware that the cost of post secondary education is very expensive and in order to make your life as stress free as possible, we are giving you CLEX for free at no charge with no obligation to purchase for as long as you need it. No three month trial like most service providers.
          </p>
          <p class="large-text">
            CLEX PLUS will offer students the option to purchase additional learning modules, that will help provide further learning support on top of CLEX. It is our intention to keep our learning module prices as low as possible, no more than the cost of a hamburger. 
          </p>
          <p class="large-text">
            Should you purchase a module or two from us, <strong>CLEX will still remain free to use at all times</strong>.
          </p>
        </div>
        <div class="hidden-xs sm-col-3">
          <AdBlock :slot-id="2" :count="1"></AdBlock>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'


export default {
    components: {
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body {background:#FFFFFF;}
  .max800 {max-width:750px;}

  .ad-block {float:right;}

  .bottom-banner .banner-copy { padding: 10%; }
  .bottom-banner p { font-size: 50px; line-height: 50px; }

  @media only screen and (max-width:1600px) {
    .banner-with-copy .banner-copy { padding: 5%; }
  }

  @media only screen and (max-width:1200px) {
    .banner-with-copy .banner-copy { padding: 3% 5% 0px 5%; }
    .banner-with-copy h1 { font-size: 50px; }
    .banner-with-copy p { font-size: 30px; line-height: 34px; margin: 30px 0px; }
    .bottom-banner p { font-size: 30px; line-height: 34px; margin: 30px 0px; }
    .banner-with-copy .btn-pub { font-size: 20px; }
    .ad-content .inner { padding: 0px 200px 0px 0px; }
  }

  @media only screen and (max-width:766px) {
    .ad-content .inner { padding: 0px 0px 0px 0px; }
    .ad-content .ad-block { display: none; }

    .banner-with-copy h1 { font-size: 30px; }
    .banner-with-copy p { font-size: 16px; line-height: 20px; margin: 20px 0px; }

    .bottom-banner p { font-size: 24px; line-height: 28px; margin: 30px 0px; }
  }
</style>



// WEBPACK FOOTER //
// AboutUsPage.vue?b775c750